import { getCommittedDeliveriesForProduct } from '@/helpers/productListHelpers/productListGetters'

const MAP_TYPE_DISCOUNT_RATE = {
  MAX: 'maxDiscountRate',
  STANDARD: 'stdDiscountRate',
}

export const getProductListMaxDiscountsRates = (
  productList,
  committedDeliveries,
  internationalDeliveries,
) =>
  getProductListDiscountRates(
    productList,
    committedDeliveries,
    MAP_TYPE_DISCOUNT_RATE.MAX,
    internationalDeliveries,
  )
export const getProductListStandardDiscountsRates = (
  productList,
  committedDeliveries,
  internationalDeliveries,
) =>
  getProductListDiscountRates(
    productList,
    committedDeliveries,
    MAP_TYPE_DISCOUNT_RATE.STANDARD,
    internationalDeliveries,
  )

const getProductListDiscountRates = (
  productList,
  committedDeliveries,
  rateType,
  internationalDeliveries,
) => {
  const productListDiscountsLimits = {}
  productList.forEach(
    product =>
      (productListDiscountsLimits[product.id] = getProductDiscountRates(
        product,
        getCommittedDeliveriesForProduct(product, committedDeliveries, internationalDeliveries),
        rateType,
      )),
  )
  return productListDiscountsLimits
}

const getProductDiscountRates = (product, committedDeliveries, rateType) => {
  const productDiscountsLimits = {}
  product.zoneList.forEach(
    zone =>
      (productDiscountsLimits[zone.id] = getDiscountRateForZone(
        zone,
        committedDeliveries,
        rateType,
      )),
  )
  return productDiscountsLimits
}

const getDiscountRateForZone = (zone, numDeliveries, rateType) => {
  const discount =
    zone.discounts.find(discount => discount.shippingUntil >= numDeliveries) ??
    zone.discounts[zone.discounts.length - 1]

  return discount[rateType]
}
